import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

export function Modal({ isOpen, onClose, children, className }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div 
        className={cn(
          'relative bg-slate-900 border border-slate-800 rounded-2xl w-full max-w-lg',
          className
        )}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-slate-800 transition-colors text-slate-400 hover:text-white"
          data-testid="modal-close-btn"
        >
          <X size={20} />
        </button>
        {children}
      </div>
    </div>
  );
}
